import React from 'react'
import PropTypes from 'prop-types'
import CurrentAverageCostOfLaborSummaryReport from './CurrentAverageCostOfLaborSummaryReport'
import { round } from '../../../../../helpers'
import { range, find, get } from 'lodash'
import DataFilters from '../../DataFilters'

export default function CurrentAverageCostOfLaborSummary(props) {

    const groups = ['E', 'M', 'P', 'S']

    const groupsNames = {
        'E': 'Executive',
        'M': 'Management',
        'P': 'Professional',
        'S': 'Support',
    }

    const onApply = (filters) => {
        props.onApply(filters, 'CurrentAverageCostOfLaborSummary')
    }

    const levelsData = []
    const groupSummary = []
    const groupCalculation = []
    const groupTotal = {
        current: {
            totalN: 0,
            totalPercent: 0,
            totalSalary: 0,
            totalActualCost: 0,
            totalAverageRows: 0,
        }
    }

    range(14).forEach(level => {
        const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
        const groupData = {}
        groups.forEach(g => {
            groupData[g] = {
                level: '',
                title: '',
                current: { n: '', percent: '', salary: '' },
            }
        })

        groupSummary[level] = {
            current: { nSummary: 0, actualCostSummary: 0, percentSummary: 0, salarySummary: 0 },
        }

        groupCalculation[level] = {
            current: { avgSalary: 0, levelN: 0, actualCost: 0}
        }

        levelData.forEach(ld => {
            const groupKey = ld.job_grade.slice(0, 1)
            const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

            groupData[groupKey].level = ld.job_grade
            groupData[groupKey].title = ld.job_title

            if (dataInReport) {
                
                groupCalculation[level].current.levelN = dataInReport ? dataInReport.total : 0
                groupCalculation[level].current.avgSalary = get(dataInReport, 'avg_annual_base_salary', 0) / (props.selectedCurrency !== null ? props.selectedCurrency.dollar_rate : 1)
                groupCalculation[level].current.actualCost = groupCalculation[level].current.avgSalary * groupCalculation[level].current.levelN

                groupSummary[level].current.nSummary += groupCalculation[level].current.levelN
                groupSummary[level].current.salarySummary = round((groupSummary[level].current.salarySummary ) + groupCalculation[level].current.avgSalary)
                groupSummary[level].current.actualCostSummary = round(groupSummary[level].current.actualCostSummary + groupCalculation[level].current.actualCost)
            }
        })

        groupSummary[level].current.salarySummary = round((groupSummary[level].current.actualCostSummary / groupSummary[level].current.nSummary))
        
        if (groupSummary[level].current.salarySummary > 0) {
            groupTotal.current.totalAverageRows += 1;
        }
        groupTotal.current.totalN += groupSummary[level].current.nSummary
        groupTotal.current.totalSalary = round(groupTotal.current.totalSalary + groupSummary[level].current.salarySummary)
        groupTotal.current.totalActualCost = groupTotal.current.totalActualCost + groupSummary[level].current.actualCostSummary
        levelsData.push(groupData)
    })

    range(14).forEach(level => {
        groupSummary[level].current.percentSummary = round((groupSummary[level].current.actualCostSummary / groupTotal.current.totalActualCost) * 100)
        groupTotal.current.totalPercent = round(groupTotal.current.totalPercent + groupSummary[level].current.percentSummary)
    })

    /**
     * Below is the Display logic for Rows
     */
    range(14).forEach(level => {
        groupSummary[level].current.percentSummary = groupSummary[level].current.percentSummary.toFixed(1)
    })

    groupTotal.current.totalPercent = round(groupTotal.current.totalPercent, 0)
    groupTotal.current.totalSalary = round(groupTotal.current.totalSalary / groupTotal.current.totalAverageRows)

    return (
        <React.Fragment>
            <DataFilters
                fetchedFilterData={props.fetchedFilterData}
                filtersData={props.filtersData}
                onDataFilterSelect={props.onDataFilterSelect}
                componentName={'CurrentAverageCostOfLaborSummary'}
                reportFilters={props.reportFilters}
                onApply={onApply}
                resetFilter={props.resetFilter}
                reportFiltersType={props.reportFiltersType}
                reportDataChanged={props.reportDataChanged}
            />
            <CurrentAverageCostOfLaborSummaryReport currencyCode={props.selectedCurrency !== null ? props.selectedCurrency.short_code : 'USD'} groupTotal={groupTotal} groupSummary={groupSummary} groups={groups} groupsNames={groupsNames} levelsData={levelsData}></CurrentAverageCostOfLaborSummaryReport>
        </React.Fragment>
    )
}

CurrentAverageCostOfLaborSummary.propTypes = {
    masterData: PropTypes.object.isRequired,
    onDataFilterSelect: PropTypes.func.isRequired,
    reportFilters: PropTypes.object.isRequired,
    reportData: PropTypes.array.isRequired,
    onApply: PropTypes.func.isRequired,
}
